import { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { motion, MotionConfig } from "framer-motion";
import Lenis from "lenis";
import Header from "./Header";
import Footer from "./Footer";
import MobileBar from "./MobileBar";
import CookieConsent from "./CookieConsent";
import { track } from "@/lib/analytics";

function useSmoothScroll() {
  const lenisRef = useRef(null);
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); lenisRef.current = null; };
  }, []);
  return lenisRef;
}

export default function Layout() {
  const { pathname, hash } = useLocation();
  const lenisRef = useSmoothScroll();

  useEffect(() => {
    const t = setTimeout(() => {
      const el = hash ? document.getElementById(hash.slice(1)) : null;
      const lenis = lenisRef.current;
      if (el) {
        if (lenis) lenis.scrollTo(el, { offset: -90 });
        else el.scrollIntoView();
      } else if (lenis) lenis.scrollTo(0, { immediate: true });
      else window.scrollTo(0, 0);
    }, hash ? 120 : 0);
    return () => clearTimeout(t);
  }, [pathname, hash, lenisRef]);

  useEffect(() => {
    const onClick = (e) => {
      const el = e.target.closest?.("[data-track]");
      if (el) track(el.getAttribute("data-track"), { page: window.location.pathname });
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  return (
    <MotionConfig reducedMotion="user">
      <div className="grain min-h-screen">
        <Header />
        <motion.main id="contenu" key={pathname} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
          <Outlet />
        </motion.main>
        <Footer />
        <MobileBar />
        <CookieConsent />
      </div>
    </MotionConfig>
  );
}
